import React from 'react';
import Box from 'atomic/box';
import classNames from 'classnames';
import WidgetImageTextProps from './widget-image-text.props';

import './widget-image-text.scss';

const WidgetImageText: React.FC<WidgetImageTextProps> = props => (
    <div className="w-image-text">
        <Box className="w-image-text-box">
            <div
                className={classNames({
                    'w-image-text-box-image': true,
                    'w-image-text--left': props.data.imagePosition === 'left',
                    'w-image-text--right': props.data.imagePosition === 'right'
                })}
            >
                <img src={props.data.img} alt={props.data.alt}/>
            </div>
            <div dangerouslySetInnerHTML={{ __html: props.data.html }}/>
        </Box>
    </div>
);

export default WidgetImageText;
